'use client';

import { useEffect } from 'react';

import EmptyState from '../components/EmptyState';

interface IErrorStateProps {
  error: Error;
}

const ErrorState: React.FC<IErrorStateProps> = ({ error }) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <EmptyState />;
};

export default ErrorState;
